class SiteSearch {
  constructor() {
    document.addEventListener(
      'facetwp-loaded',
      this.dynamicSearchPageTitle.bind(this),
    );
    document.addEventListener(
      'facetwp-refresh',
      this.dynamicSearchPageTitle.bind(this),
    );
  }

  stripHtmlTags = (text) => {
    if (text === null || text === '') return false;
    else text = text.toString();
    // HTML tag with a null string.
    return text.replace(/(<([^>]+)>)/gi, '');
  };

  dynamicSearchPageTitle() {
    const FWP = window?.FWP;
    if (!FWP) {
      return;
    }

    const siteSearch = window?.siteSearch;
    if (typeof siteSearch !== 'object') {
      return;
    }

    const pageTitleWrapper = document.querySelector('.search-page__title');
    if (! (pageTitleWrapper instanceof HTMLElement)) {
      return;
    }

    const searchQuery = FWP?.facets?.s || '';
    if (searchQuery?.length > 0) {
      pageTitleWrapper.innerHTML = (siteSearch?.queryTextHolder || '').replace(
        '%s',
        String(this.stripHtmlTags(searchQuery)),
      );
    } else {
      pageTitleWrapper.innerHTML = siteSearch?.defaultPageTitle || '';
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  new SiteSearch();
});
